import { RootState } from '../types'

export const getMainCategorySelector = (state: RootState) => state.category
